import { EOfferScopeCapType } from '../../enum'

// Create a union type of all possible values from the enum
type IOfferScopeCapTypeLangKey = `${EOfferScopeCapType}`

export type IOfferScopeCapTypeLang = {
	offer_scope_cap_type: Record<IOfferScopeCapTypeLangKey, string>
}

const langEntries = Object.entries(EOfferScopeCapType).map(
	([key, value]) => [value, `offer_scope_cap_type.${value}`]
)

const langObj: Record<IOfferScopeCapTypeLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SCOPE_CAP_TYPE_LANG_KEY: IOfferScopeCapTypeLang = {
	offer_scope_cap_type: langObj
}